import React, { useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Stack,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { styles } from "./style";

import GetImages from "@/components/GetImages";

import { IPrescriptionTemplateValue } from "@/models/ApiRequestResponse/doctor";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  prescriptionDetails,
  setSelectedTemplate,
} from "@/store/slices/doctor/prescription";

type TemplateSelectorProps = {
  onSelect: (value: IPrescriptionTemplateValue) => void;
};

type TemplateItemProps = {
  value: any;
  onClick: () => void;
  isSelected: boolean;
  isEmpty?: boolean;
};

const TemplateItem: React.FC<TemplateItemProps> = ({
  value,
  onClick,
  isSelected,
  isEmpty,
}) => {
  return (
    <div
      onClick={onClick}
      style={isSelected ? styles.selectedItem : styles.item}
    >
      {isEmpty && !isEmpty && (
        <GetImages
          name="PrescriptionDefaultSmallIcon"
          width="18.73"
          height="20.33"
        />
      )}
      <Typography component="span">{value?.name}</Typography>
    </div>
  );
};

const TemplateSelector: React.FC<TemplateSelectorProps> = ({ onSelect }) => {
  const [showTemplateList, setShowTemplateList] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [searchText, setSearchText] = useState("");
  const [filteredTemplate, setFilteredTemplate] = useState([]);

  const {
    template: { list },
  } = useAppSelector((s) => s.prescription);
  const { selectedTemplate } = useAppSelector(prescriptionDetails);

  const dispatch = useAppDispatch();

  const templateList =
    searchText.length > 0 && filteredTemplate?.length === 0
      ? []
      : filteredTemplate?.length === 0
      ? list
      : filteredTemplate;

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);

    setFilteredTemplate(
      list?.filter((item) =>
        item?.name?.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleSelect = (value: IPrescriptionTemplateValue) => {
    dispatch(setSelectedTemplate({ id: value?.id, name: value?.name }));
    onSelect(value);
    setShowTemplateList(false);
    setSearchText(value?.name);
    toggleDropdown();
  };

  const handleShowTemplateList = () => {
    setShowTemplateList(!showTemplateList);
    toggleDropdown();
  };

  return (
    <Stack direction="column" spacing={showTemplateList ? 1 : 0}>
      <Box sx={styles.searchTemplateContainer} onClick={handleShowTemplateList}>
        <GetImages name="PrescriptionDefaultSmallIcon" width="24" height="20" />
        <InputBase
          value={searchText}
          onChange={handleSearch}
          placeholder="Search Templates"
          fullWidth
          sx={{ fontWeight: 400 }}
        />
        <IconButton size="small">
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </Box>
      {open && (
        <Grid item sx={styles.browseTemplateBox}>
          {templateList.length > 0 ? (
            templateList?.map((detail: any) => (
              <TemplateItem
                key={detail.id}
                value={detail}
                onClick={() => handleSelect(detail)}
                isSelected={selectedTemplate?.id === detail.id}
              />
            ))
          ) : (
            <TemplateItem
              value={{ id: 0, name: "No templates found" }}
              onClick={() => {}}
              isEmpty={true}
              isSelected={false}
            />
          )}
        </Grid>
      )}
    </Stack>
  );
};

export default TemplateSelector;
